exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".erg-components-ProgressBar{height:5px;max-height:5px;overflow:hidden}", "", {"version":3,"sources":["/./node_modules/@ergeon/erg-components-react/lib/table/node_modules/@ergeon/erg-components-react/lib/table/ProgressBar.scss"],"names":[],"mappings":"AAAA,4BACE,WACA,eACA,eAAgB,CACjB","file":"ProgressBar.scss","sourcesContent":[".erg-components-ProgressBar {\n  height: 5px;\n  max-height: 5px;\n  overflow: hidden;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?sourceMap!./~/sass-loader?sourceMap&includePaths[]=/home/circleci/project/bower_components&includePaths[]=/home/circleci/project/node_modules!./~/postcss-loader!./~/@ergeon/erg-components-react/lib/table/ProgressBar.scss
 ** module id = 1156
 ** module chunks = 0
 **/